import React from 'react';
import { 
  Shield, Users, BarChart3, LogOut, CreditCard, UserCheck, FileText, X
} from 'lucide-react';

const UserManagerSidebar = ({ 
  activeTab, 
  setActiveTab, 
  handleLogout,
  appSettings,
  appSettingsLoaded,
  appSafeSettings,
  sidebarOpen = false,
  setSidebarOpen
}) => {
  // Limited menu items for USER_MANAGER role
  const menuItems = [
    { id: 'overview', icon: BarChart3, label: 'Overview' },
    { id: 'users', icon: Users, label: 'Users' },
    { id: 'user-approvals', icon: UserCheck, label: 'User Approvals' },
    { id: 'subscriptions', icon: CreditCard, label: 'Subscriptions (View Only)' },
  ];

  return (
    <div className={`admin-sidebar ${sidebarOpen ? 'mobile-open' : ''} fixed top-0 left-0 bottom-0 w-80 bg-gradient-to-b from-green-600 to-blue-600 text-white flex flex-col z-50`}>
      {/* Header */}
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center gap-3 mb-2">
          {appSettings?.product_logo ? (
            <img
              src={appSettings.product_logo}
              alt="Logo"
              className="h-8 w-auto object-contain"
            />
          ) : (
            <Shield size={32} className="text-white" />
          )}
          <div className="flex-1">
            <div className={`app-name-container ${appSettingsLoaded ? 'loaded' : ''}`}>
              <h2 className="text-xl font-bold text-white">
                {appSafeSettings?.product_name}
              </h2>
            </div>
            {!appSettingsLoaded && (
              <div className="app-name-placeholder mb-2" style={{height: '1.75rem', backgroundColor: 'rgba(255,255,255,0.3)'}}></div>
            )}
            <p className="text-sm text-white/80">
              User Manager Dashboard
            </p>
          </div>
          {/* Mobile Close Button */}
          <button
            onClick={() => setSidebarOpen && setSidebarOpen(false)}
            className="md:hidden bg-white/10 hover:bg-white/20 rounded p-1 transition-colors"
          >
            <X size={20} />
          </button>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-6">
        <div className="space-y-2">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`
                w-full p-4 rounded-lg text-left transition-all duration-200
                flex items-center gap-3 text-sm font-medium
                ${activeTab === item.id 
                  ? 'bg-white/20 text-white border-l-4 border-white' 
                  : 'text-white/80 hover:bg-white/10 hover:text-white'
                }
              `}
            >
              <item.icon size={18} />
              {item.label}
            </button>
          ))}
        </div>
        
        {/* Role indicator */}
        <div className="mt-6 p-3 bg-white/10 rounded-lg">
          <p className="text-xs text-white/60 mb-1">Your Role</p>
          <p className="text-sm font-medium text-white">User Manager</p>
          <p className="text-xs text-white/70 mt-1">Limited admin access</p>
        </div>
      </nav>

      {/* Logout */}
      <div className="p-6 border-t border-white/10">
        <button
          onClick={handleLogout}
          className="w-full p-3 bg-white/10 hover:bg-white/20 border border-white/20 rounded-lg text-white transition-all duration-200 flex items-center justify-center gap-2 text-sm font-medium"
        >
          <LogOut size={16} />
          Logout
        </button>
      </div>
    </div>
  );
};

export default UserManagerSidebar;